/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Device_ChromeInputs */

const en_funnel_device_chrome = /** @type {(inputs: Funnel_Device_ChromeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome extension`)
};

const es_funnel_device_chrome = /** @type {(inputs: Funnel_Device_ChromeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión de Chrome`)
};

/**
* | output |
* | --- |
* | "Chrome extension" |
*
* @param {Funnel_Device_ChromeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_device_chrome = /** @type {((inputs?: Funnel_Device_ChromeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Device_ChromeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_device_chrome(inputs)
	return en_funnel_device_chrome(inputs)
});